import {
  Box,
  Button,
  Card,
  Stack,
  TextField,
  Typography,
  Drawer,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import EditBookingModal from "./editBookingModal";
import CompleteBooking from "./completeBooking";
import EmailIcon from "@mui/icons-material/Email";
import PrintIcon from "@mui/icons-material/Print";
import { useState } from "react";
import PrintModal from "./printModal";
import InvitationCard from "./invitationCard";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";
import BadgeIcon from "@mui/icons-material/Badge";
import CompleteParty from "./completeParty";
import CancelBooking from "./cancelBooking";
import MaleIcon from "@mui/icons-material/Male";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FemaleIcon from "@mui/icons-material/Female";
import DatePickerWithBadges from "../../../util/general/DatePickerWithBadges";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PaymentRequest from "./paymentRequest";
import { set } from "lodash";
const BookedEvent = (props) => {
  const dates =
    props.completedBookings.length === 0
      ? ["All"]
      : props.completedBookings
          .map((e) => e.bookingDetail.party_date)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort((a, b) => a.localeCompare(b));

  const [printModal, setPrintModal] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [invtCardModal, setInvtCardModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("Upcoming");
  const [filterName, setFilterName] = useState("");
  const [openAction, setOpenAction] = useState(false);
  const [editCaseData, setEditCaseData] = useState();

  console.log(editCaseData);
  const DrawerList = ({ e }) => (
    <Drawer
      open={openAction}
      onClose={() => setOpenAction(false)}
      anchor="right"
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(227, 227, 234, 0.127)", // Blue with 50% opacity
        },
      }}
      PaperProps={{
        elevation: 3, // Set elevation to 0 to remove the box shadow
      }}
    >
      <Box sx={{ width: "250px" }} role="presentation">
        <Stack
          direction="column"
          flexWrap="wrap"
          p={2} // alignItems={"center"}
          spacing={2}
        >
          <EditBookingModal eventData={e} reFreshData={props.reFreshData} />
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            sx={{ width: "fit-content" }}
            onClick={() => {
              setPrintModal(true);
              setPrintData(e);
            }}
          >
            Print / Detail
          </Button>

          <Button
            variant="contained"
            startIcon={<EmailIcon />}
            sx={{ width: "fit-content" }}
            onClick={() => {
              setInvtCardModal(true);
              setPrintData(e);
            }}
          >
            Invitation Card
          </Button>
          <CancelBooking eventData={e} reFreshData={props.reFreshData} />

          <CompleteParty eventData={e} reFreshData={props.reFreshData} />
          <PaymentRequest eventData={e} reFreshData={props.reFreshData} />
        </Stack>
      </Box>
    </Drawer>
  );
  const toRenderBooking =
    props.completedBookings.length === 0 ? (
      <>No Pending Bookings</>
    ) : (
      <Stack sx={{ maxWidth: 800 }}>
        {props.completedBookings
          .sort((a, b) =>
            `${a.bookingDetail.party_date}${a.bookingDetail.party_time}`.localeCompare(
              `${b.bookingDetail.party_date}${b.bookingDetail.party_time}`
            )
          )
          .filter((item) =>
            selectedDate == "Invalid Date"
              ? dates.includes(item.bookingDetail.party_date)
              : selectedDate === "Upcoming"
              ? item.bookingDetail.party_date === dates[0]
              : item.bookingDetail.party_date === selectedDate
          )
          .filter((item) =>
            `${item.bookingDetail.celebrant.toLowerCase()}`.includes(
              filterName.toLowerCase()
            )
          )
          .map((e) => (
            <Card
              key={e._id}
              variant="outlined"
              sx={{
                maxWidth: 650,
                marginTop: "30px",
                borderWidth: "2px",
                padding: "10px",
                paddingTop: "0",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.112)",
                "&:hover": {
                  boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.187)",
                },
              }}
            >
              <Stack direction="column" justifyContent="space-between">
                <Box>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems={"center"}
                    sx={{
                      width: "100%",
                      fontWeight: "600",
                      marginBottom: "5px",
                      borderBottom: "2px solid #c3bcc67d",
                    }}
                  >
                    <Stack>
                      <Stack
                        flexDirection={"row"}
                        style={{ color: "#b68014", fontSize: "18px" }}
                      >
                        <Box>{e.bookingDetail.party_date.slice(5)}</Box>
                        <Box sx={{ paddingLeft: "20px", color: "black" }}>
                          {convertTo12HourTimeCompact(
                            e.bookingDetail.party_time
                          )}
                        </Box>
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        fontSize: "20px",
                      }}
                    >
                      {e.bookingDetail.celebrant}
                      {e.bookingDetail.gender === "Boy" && (
                        <MaleIcon sx={{ color: "#1e78d1" }} />
                      )}
                      {e.bookingDetail.gender === "Girl" && (
                        <FemaleIcon sx={{ color: "#e2589d" }} />
                      )}
                    </Stack>
                    <div>
                      <Button
                        onClick={() => {
                          setEditCaseData(e);
                          setOpenAction(true);
                        }}
                      >
                        <ArrowBackIosNewIcon />
                      </Button>
                    </div>
                  </Stack>

                  <Stack
                    flexDirection={"row"}
                    width={"80%"}
                    justifyContent={"flex-start"}
                    alighnItems={"center"}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        paddingLeft: "5px",
                      }}
                    >
                      {e.bookingDetail.theme}
                    </Stack>
                    <Stack
                      width={"fit-content"}
                      height={"fit-content"}
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        fontSize: "14px",
                        width: "fit-content",
                        color: "white",
                        padding: "2px 8px",
                        marginLeft: "5px",

                        borderRadius: "5px",

                        bgcolor:
                          e.package.package_name === "Giant Room" ||
                          e.package.package_name === "Giant Party"
                            ? "blue"
                            : e.package.package_name === "Large Room" ||
                              e.package.package_name === "Large Party"
                            ? "orange"
                            : e.package.package_name === "Medium Room" ||
                              e.package.package_name === "Medium Party"
                            ? "green"
                            : "purple",
                      }}
                    >
                      {e.package.package_name.slice(0, -5)}
                    </Stack>
                  </Stack>
                  <Stack mt="10px" direction="column" spacing={3}>
                    <Stack direction="row" spacing={7}>
                      <Stack direction="row" sx={{ fontSize: "16px" }}>
                        <EscalatorWarningIcon sx={{ mr: "10px" }} />{" "}
                        {e.bookingDetail.num_kid}/{e.bookingDetail.num_adult}
                      </Stack>
                      <Stack direction="row" sx={{ fontSize: "16px" }}>
                        <LocalPizzaIcon sx={{ mr: "10px" }} />{" "}
                        {e.bookingDetail.cheese_pizza}C{" "}
                        {e.bookingDetail.pepperoni_pizza}P{" "}
                        {e.bookingDetail.veggie_pizza}V
                      </Stack>
                      <Stack direction="row" sx={{ fontSize: "16px" }}>
                        <CardGiftcardIcon sx={{ mr: "10px" }} />{" "}
                        {e.package.free_return_pass} return pass
                      </Stack>
                    </Stack>

                    <Stack
                      direction="row"
                      spacing={7}
                      sx={{ height: "fit-content" }}
                    >
                      {e.bookingDetail.upgrade_gummy_dragon ? (
                        <Stack direction={"row"} alignItems="center">
                          <CheckCircleIcon
                            sx={{ color: "green", fontSize: "20px" }}
                          />
                          <Box>Gummy dragon </Box>
                        </Stack>
                      ) : null}

                      {e.bookingDetail.upgrade_luxury_package ? (
                        <Stack direction={"row"} alignItems="center">
                          <CheckCircleIcon
                            sx={{ color: "green", fontSize: "20px" }}
                          />
                          <Box>Luxury package </Box>
                        </Stack>
                      ) : null}

                      {e.bookingDetail.upgrade_unlimited_playtime ? (
                        <Stack direction={"row"} alignItems="center">
                          <CheckCircleIcon
                            sx={{ color: "green", fontSize: "20px" }}
                          />
                          <Box>Unlimted play time </Box>
                        </Stack>
                      ) : null}

                      {e.bookingDetail.bring_own_food ? (
                        <Stack direction={"row"} alignItems="center">
                          <CheckCircleIcon
                            sx={{ color: "green", fontSize: "20px" }}
                          />
                          <Box>Outside food </Box>
                        </Stack>
                      ) : null}
                    </Stack>
                  </Stack>

                  {"Note: ".includes(e.bookingDetail.special_request) ? null : (
                    <Stack direction={"row"} alignItems="center">
                      <Box>{e.bookingDetail.special_request}</Box>
                    </Stack>
                  )}
                </Box>
              </Stack>
            </Card>
          ))}
      </Stack>
    );

  return (
    <Stack sx={{ width: "100%", height: `calc(100vh - 260px)` }}>
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        sx={{ height: "60px" }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePickerWithBadges
            partyDates={dates}
            onDateChange={(e) => {
              setSelectedDate(e);
            }}
          />
        </LocalizationProvider>

        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-standard-label"></InputLabel>
          <TextField
            sx={{
              "& .MuiOutlinedInput-input": {
                height: "8px",
              },
            }}
            // label="Name"
            // variant="standard"
            value={filterName}
            onChange={(e) => {
              setFilterName(e.target.value);
              if (e.target.value.length > 0) {
                setSelectedDate("Invalid Date");
              } else setSelectedDate("Upcoming");
            }}
          ></TextField>
        </FormControl>
      </Stack>
      {openAction && editCaseData && <DrawerList e={editCaseData} />}

      {invtCardModal && (
        <InvitationCard
          inviteInfo={printData}
          onClose={() => setInvtCardModal(false)}
        />
      )}

      {printModal && (
        <PrintModal
          closeModal={() => setPrintModal(false)}
          data={printData}
        ></PrintModal>
      )}
      <Box
        sx={{
          height: `calc(100vh - 280px)`,
          overflowY: "auto",
          // borderTop: "2px solid #a4a5d8",
          marginTop: "5px",
        }}
      >
        {toRenderBooking}
      </Box>
    </Stack>
  );
};

export default BookedEvent;
